import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { FavouriteToggle } from './FavouriteToggle'
import { useToggleFavourite } from './useToggleFavourite'
import type { Recipe } from './types'

interface RecipeCardProps {
  recipe: Recipe
}

export function RecipeCard({ recipe }: RecipeCardProps) {
  const { t } = useTranslation('recipes')
  const toggleMutation = useToggleFavourite()

  return (
    <div className="relative bg-surface rounded-xl border border-line p-4 flex items-center justify-between gap-3">
      <Link
        to="/recipes/$recipeId"
        params={{ recipeId: recipe.id }}
        className="min-w-0 flex-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded"
      >
        <p className="font-semibold text-ink truncate">{recipe.name}</p>
        <p className="text-xs text-muted mt-0.5">{t('card.serves', { count: recipe.servingSize })}</p>
      </Link>
      <FavouriteToggle
        recipeId={recipe.id}
        name={recipe.name}
        isFavourite={recipe.isFavourite}
        isPending={toggleMutation.isPending && toggleMutation.variables?.recipeId === recipe.id}
        onToggle={(id, fav) => toggleMutation.mutate({ recipeId: id, isFavourite: fav })}
      />
    </div>
  )
}
